export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-right2-6ae91c64667e2630dbe140cda2a0fb03.png";